<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i9Sspb/tc-custom/9781504083744.jpg?1728155727724" alt="This image is the cover for the book Elmer Gantry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elmer Gantry
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A drunken womanizer succeeds as a preacher in 1920s evangelical America in this satire by the Nobel and Pulitzer Prize–winning author of <i>Main Street</i>.</b></p><p> Elmer Gantry is unsure what do to with his future. The captain of the college football team, he doesn’t care much for his classes or his uptight classmates, but he does enjoy smoking, drinking, and women. Then a preacher comes to town, inviting Elmer to a revival meeting, and it places him on a path to greatness. </p><p> The silver-tongued Elmer sets out to save souls as a preacher, but he remains a narcissistic, self-indulgent, shallow, and philandering man. As he ascends to power within the church, many souls suffer in the hypocrite’s wake . . . </p> First published in 1926, <i>Elmer Gantry</i> scandalized readers across the United States. A landmark portrait of 1920s America, it is one of the greatest, most penetrating and vital satires ever.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sinclair Lewis
      </h2>
      
      <p class="authorDescription body article">Sinclair Lewis (1885&ndash;1951) was the first American writer to win the Nobel Prize in Literature. In 1926 Lewis&rsquo;s novel <I>Arrowsmith</I> garnered the Pulitzer Prize, which the author refused. His work has been lauded for its critical insight into capitalism and materialist culture in America.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4784227e